export const environment = {
    production: true,
    apiUrl: 'https://api.aavartam.com'
};
